/*
 * @Description: 字典枚举
 * @Author: PF
 * @Date: 2024-04-24 09:50:36
 * @LastEditors: PF
 * @LastEditTime: 2025-03-27 10:32:35
 */

/**
 * 类型：'数据标签'
 * @returns
 */
export function getZdSjbq () {
  return {
    list: [
      { id: '66970504-c40d-4899-909e-22f7f46f61e5', bt: '姓名', dm: '1' },
      { id: 'a2dfab5e-5d8c-405f-a8f6-0115da16072d', bt: '性别', dm: '2' },
      { id: '4414b44c-0431-4b78-ac97-48526ce58ae2', bt: '层次', dm: '3' },
      { id: 'ee19eb7b-46ce-4c69-98bf-b3d013512efb', bt: '专业', dm: '4' },
      { id: 'e6527e4d-c5a4-43ec-87a1-ffc3fc198135', bt: '学制', dm: '5' },
      { id: 'c9e4be3c-1f74-4dc5-a040-13b01afd3ccb', bt: '专业编号', dm: '6' },
      { id: 'e53f822a-615b-471e-8030-988c5e79a26f', bt: '身份证号', dm: '7' },
      { id: 'c6075840-7ba1-4780-87ef-35caf95609a4', bt: '证书编号', dm: '8' },
      { id: '6d8d3289-a640-401b-8d95-32702dd0ac1e', bt: '校名', dm: '9' },
      { id: '48387f6f-d58d-4961-8a63-ac472a2dc23d', bt: '校长', dm: '10' },
      { id: '30ed81ac-8e3b-4dd3-93d5-ab29114619c3', bt: '出生日期-年', dm: '11' },
      { id: '2b8e2d2c-cd58-4401-8528-eccdf997e097', bt: '当前日期-年', dm: '12' },
      { id: '751e2bd6-4cdc-47a2-838b-385bb0c1e18c', bt: '出生日期-月', dm: '13' },
      { id: '1513b158-41a4-4953-b4f3-6b8bb2ce68a0', bt: '当前日期-月', dm: '14' },
      { id: 'e2f395f1-851f-48a9-bc05-83fc3779b311', bt: '出生日期-日', dm: '15' },
      { id: 'a06ee8f4-8d4d-4eef-bbe7-45a8d5eca7c2', bt: '当前日期-日', dm: '16' },
      { id: 'c0314113-3f25-4632-bf64-a273903af1bd', bt: '入学日期-年', dm: '17' },
      { id: 'e1a15ffc-830c-4e85-bde7-9edaaf50d701', bt: '毕业日期-年', dm: '18' },
      { id: '27667bbb-9b11-4c12-a34d-aca5a3c0b237', bt: '入学日期-月', dm: '19' },
      { id: 'd36cc747-b9fc-4574-a088-8cf543bcfdc9', bt: '毕业日期-月', dm: '20' },
      { id: '6dd83d4f-ccf6-46d3-97f6-96a942352b24', bt: '自定义文本', dm: '21' },
      { id: '42df52b2-8315-4023-bba5-853daf44d36a', bt: '自定义图片', dm: '22' }
    ],
    dm1: '66970504-c40d-4899-909e-22f7f46f61e5',
    dm2: 'a2dfab5e-5d8c-405f-a8f6-0115da16072d',
    dm3: '4414b44c-0431-4b78-ac97-48526ce58ae2',
    dm4: 'ee19eb7b-46ce-4c69-98bf-b3d013512efb',
    dm5: 'e6527e4d-c5a4-43ec-87a1-ffc3fc198135',
    dm6: 'c9e4be3c-1f74-4dc5-a040-13b01afd3ccb',
    dm7: 'e53f822a-615b-471e-8030-988c5e79a26f',
    dm8: 'c6075840-7ba1-4780-87ef-35caf95609a4',
    dm9: '6d8d3289-a640-401b-8d95-32702dd0ac1e',
    dm10: '48387f6f-d58d-4961-8a63-ac472a2dc23d',
    dm11: '30ed81ac-8e3b-4dd3-93d5-ab29114619c3',
    dm12: '2b8e2d2c-cd58-4401-8528-eccdf997e097',
    dm13: '751e2bd6-4cdc-47a2-838b-385bb0c1e18c',
    dm14: '1513b158-41a4-4953-b4f3-6b8bb2ce68a0',
    dm15: 'e2f395f1-851f-48a9-bc05-83fc3779b311',
    dm16: 'a06ee8f4-8d4d-4eef-bbe7-45a8d5eca7c2',
    dm17: 'c0314113-3f25-4632-bf64-a273903af1bd',
    dm18: '27667bbb-9b11-4c12-a34d-aca5a3c0b237',
    dm19: 'e1a15ffc-830c-4e85-bde7-9edaaf50d701',
    dm20: 'd36cc747-b9fc-4574-a088-8cf543bcfdc9',
    dm21: '6dd83d4f-ccf6-46d3-97f6-96a942352b24',
    dm22: '42df52b2-8315-4023-bba5-853daf44d36a'
  }
}

// 资源类型
export function getzylx () {
  return {
    list: [
      { id: '0ea81d40-a49a-4c22-a506-dcc297067daf', name: '媒体素材', value: '1' },
      { id: '307bc7fa-57ff-4157-afcf-a81dcdefd795', name: '试题', value: '2' },
      { id: '8159d69a-45a4-4b1e-94ac-5fe88adb9451', name: '试卷', value: '3' },
      { id: '76eb48cf-e3bf-42dc-a6f7-39450fd83345', name: '课件', value: '4' },
      { id: 'c97a3111-c342-4577-b97f-bd66c5545469', name: '案例', value: '5' },
      { id: '00659268-d261-48a4-88e6-7a34a9592e25', name: '文献资料', value: '6' },
      { id: 'a83f9328-da66-4524-abc9-ff39ecfe8f80', name: '网络课程', value: '7' },
      { id: '9068970a-9086-4a38-8fd0-5245dd6e5a5b', name: '常见问题解答', value: '8' },
      { id: '2b0f17fa-b060-42ee-8909-836abe8e1246', name: '资源目录索引', value: '9' }
    ],
    meitisucai: '0ea81d40-a49a-4c22-a506-dcc297067daf',
    shiti: '307bc7fa-57ff-4157-afcf-a81dcdefd795',
    shijuan: '8159d69a-45a4-4b1e-94ac-5fe88adb9451',
    kejian: '76eb48cf-e3bf-42dc-a6f7-39450fd83345',
    anli: 'c97a3111-c342-4577-b97f-bd66c5545469',
    wenxianziliao: '00659268-d261-48a4-88e6-7a34a9592e25',
    wangluokecheng: 'a83f9328-da66-4524-abc9-ff39ecfe8f80',
    changjianwentijieda: '9068970a-9086-4a38-8fd0-5245dd6e5a5b',
    ziyuanmulusuoyin: '2b0f17fa-b060-42ee-8909-836abe8e1246'
  }
}

// 办公状态
export function getdbzt () {
  return {
    list: [
      { value: 'fbfac1ec-31c5-11ee-ae6c-b8975afcfb03', label: '临时工作' },
      { value: 'fbfac1ec-31c5-11ee-ae6c-b8975afcfbb0', label: '代课' },
      { value: '5801a053-6ff1-11ef-8e73-b8975afcfbb0', label: '会议管理' },
      { value: 'e03e5612-47ce-11ef-8e73-b8975afcfbb0', label: '作业任务' },
      { value: 'fbfac1ec-31c5-11ee-ae6c-b8775afcfbb9', label: '值班日志' },
      { value: 'fbfac1ec-31c5-11ee-ae6c-b8975afcfb02', label: '固定工作' },
      { value: '246c8b53-4341-11ef-8e73-b8975afcfbb0', label: '备课' },
      { value: '41278b0b-6586-11ee-977b-b8975afcfbb0', label: '学期教学计划' },
      { value: '6e322377-6031-11ef-8e73-b8975afcfbb0', label: '宿舍未归学生统计-宿管' },
      { value: '6e30ed2e-6031-11ef-8e73-b8975afcfbb0', label: '宿舍未归学生统计-班主任' },
      { value: '45315961-a619-11ee-8632-b8975afcfbb0', label: '巡检' },
      { value: '1a3375ef-81e9-444a-b378-4a06c87bb931', label: '工作流办理' },
      { value: '1a3375ef-81e9-444a-b378-4a06c87bb932', label: '工作流审批' },
      { value: '01af76b1-b7dd-11ed-9bba-00163e2ca12c', label: '布置作业' },
      { value: '01af76b1-b7dd-11ed-9bba-00163e2ca121', label: '批改作业' },
      { value: 'fbfac1ec-31c5-11ee-ae6c-b8975afcfbb9', label: '教学工作检查' },
      { value: '1a3375ef-81e9-444a-b378-4a06c87bb933', label: '教学工作要求' },
      { value: 'fbfac1ec-31c5-11ee-ae6c-b8975afcfbb8', label: '教学日志' },
      { value: '01af76b1-b7dd-11ed-9bba-00163e2ca129', label: '教学设计' },
      { value: 'fbfac1ec-31c5-11ee-ae6c-b8975afcfb01', label: '日常工作' },
      { value: 'af37b893-94cf-11ee-977b-b8975afcfbb0', label: '组织事务' },
      { value: '3c727266-39a6-11ef-8e73-b8975afcfbb0', label: '考勤修复' },
      { value: 'ed2010bd-0a0c-11f0-9b8d-b8975afcfbb0', label: '考核项目-考核人' },
      { value: 'ed20fce8-0a0c-11f0-9b8d-b8975afcfbb0', label: '考核项目-评价人' },
      { value: '8788d234-507e-11ee-ace6-b8975afcfbb0', label: '考试计划试卷审核' },
      { value: 'd0ca0719-506f-11ee-ace6-b8975afcfbb0', label: '考试计划试卷组卷' },
      { value: 'f81b87cb-fdf8-11ee-99b5-b8975afcfbb0', label: '规章制度阅读' },
      { value: 'da184e1a-47d2-11ef-8e73-b8975afcfbb0', label: '评教任务' },
      { value: '7c753d19-e2b2-488c-9f26-05698c301bed', label: '课件' },
      { value: 'aa8eff83-25e7-11ee-925d-b8975afcfbb0', label: '调课' }

    ],
    linshigongzuo: 'fbfac1ec-31c5-11ee-ae6c-b8975afcfb03', // 临时工作
    daike: 'fbfac1ec-31c5-11ee-ae6c-b8975afcfbb0', // 代课
    huiyiguanli: '5801a053-6ff1-11ef-8e73-b8975afcfbb0', // 会议管理
    zuoyerenwu: 'e03e5612-47ce-11ef-8e73-b8975afcfbb0', // 作业任务
    zhibanrizhi: 'fbfac1ec-31c5-11ee-ae6c-b8775afcfbb9', // 值班日志
    gudinggongzuo: 'fbfac1ec-31c5-11ee-ae6c-b8975afcfb02', // 固定工作
    beike: '246c8b53-4341-11ef-8e73-b8975afcfbb0', // 备课
    xueqijiaoxuejihua: '41278b0b-6586-11ee-977b-b8975afcfbb0', // 学期教学计划
    weiguixueshengsuguan: '6e322377-6031-11ef-8e73-b8975afcfbb0', // 宿舍未归学生统计-宿管
    weiguixueshengbanzhuren: '6e30ed2e-6031-11ef-8e73-b8975afcfbb0', // 宿舍未归学生统计-班主任
    xunjian: '45315961-a619-11ee-8632-b8975afcfbb0', // 巡检
    gongzuoliubanli: '1a3375ef-81e9-444a-b378-4a06c87bb931', // 工作流办理
    gongzuoliushenpi: '1a3375ef-81e9-444a-b378-4a06c87bb932', // 工作流审批
    buzhizuoye: '01af76b1-b7dd-11ed-9bba-00163e2ca12c', // 布置作业
    pigaizuoye: '01af76b1-b7dd-11ed-9bba-00163e2ca121', // 批改作业
    jiaoxuegongzuojiancha: 'fbfac1ec-31c5-11ee-ae6c-b8975afcfbb9', // 教学工作检查
    jiaoxuegongzuoyaoqiu: '1a3375ef-81e9-444a-b378-4a06c87bb933', // 教学工作要求
    jiaoxuerizhi: 'fbfac1ec-31c5-11ee-ae6c-b8975afcfbb8', // 教学日志
    jiaoxuesheji: '01af76b1-b7dd-11ed-9bba-00163e2ca129', // 教学设计
    richanggongzuo: 'fbfac1ec-31c5-11ee-ae6c-b8975afcfb01', // 日常工作
    zuzhishiwu: 'af37b893-94cf-11ee-977b-b8975afcfbb0', // 组织事务
    kaoqinxiufu: '3c727266-39a6-11ef-8e73-b8975afcfbb0', // 考勤修复
    kaohexiangmukaoheren: 'ed2010bd-0a0c-11f0-9b8d-b8975afcfbb0', // 考核项目-考核人
    kaohexiangmupingjiaren: 'ed20fce8-0a0c-11f0-9b8d-b8975afcfbb0', // 考核项目-评价人
    kaoshijihuashijuanzujuanshenpi: '8788d234-507e-11ee-ace6-b8975afcfbb0', // 考试计划试卷审核
    kaoshijihuashijuanzujuan: 'd0ca0719-506f-11ee-ace6-b8975afcfbb0', // 考试计划试卷组卷
    guizhangzhiduyuedu: 'f81b87cb-fdf8-11ee-99b5-b8975afcfbb0', // 规章制度阅读
    pingjiaorenwu: 'da184e1a-47d2-11ef-8e73-b8975afcfbb0', // 评教任务
    kejian: '7c753d19-e2b2-488c-9f26-05698c301bed', // 课件
    tiaoke: 'aa8eff83-25e7-11ee-925d-b8975afcfbb0' // 调课
  }
}

// 作业题型
export function getTiXing () {
  return {
    list: [
      { id: 'ea691280-774c-427d-86b8-b4c47616fa30', name: '判断', tlid: '03ab0b7c-f5c9-40a6-9adb-86daf90e578d', tlmc: '客观题' },
      { id: '39967dba-900e-4348-9bd2-cdf1f0e014b2', name: '单项选择', tlid: '03ab0b7c-f5c9-40a6-9adb-86daf90e578d', tlmc: '客观题' },
      { id: '372f630d-e7ca-47fe-9766-38e5ae5554e4', name: '多项选择', tlid: '03ab0b7c-f5c9-40a6-9adb-86daf90e578d', tlmc: '客观题' },
      { id: '66cb4116-6a03-4dfe-a640-24666a094ecf', name: '填空', tlid: '03ab0b7c-f5c9-40a6-9adb-86daf90e578d', tlmc: '客观题' },
      { id: '37d05cd3-7465-4cd4-ba09-20a5497a10f4', name: '匹配', tlid: '31b38675-1de4-4a42-a9d8-10bb8623368c', tlmc: '主观题' },
      { id: '82069608-2a51-46c8-b8f0-ede379d6612a', name: '作图', tlid: '31b38675-1de4-4a42-a9d8-10bb8623368c', tlmc: '主观题' },
      { id: '61e2219f-433e-4755-a732-b96fc505541f', name: '计算', tlid: '31b38675-1de4-4a42-a9d8-10bb8623368c', tlmc: '主观题' },
      { id: '4c4f7020-f4e6-4472-b739-627152d71132', name: '简答', tlid: '31b38675-1de4-4a42-a9d8-10bb8623368c', tlmc: '主观题' },
      { id: '8cac5b6b-01f6-4fc7-a744-d25bb9222cef', name: '问答', tlid: '31b38675-1de4-4a42-a9d8-10bb8623368c', tlmc: '主观题' },
      { id: '8f6cd05c-874b-4fdc-ac99-8d97c4b95957', name: '论述', tlid: '31b38675-1de4-4a42-a9d8-10bb8623368c', tlmc: '主观题' },
      { id: '782ecc56-3a70-4d96-bac0-ef1c981dbf43', name: '实验', tlid: '31b38675-1de4-4a42-a9d8-10bb8623368c', tlmc: '主观题' },
      { id: '89e26ffa-7393-42e0-acd6-caa551fba3a6', name: '作文', tlid: '31b38675-1de4-4a42-a9d8-10bb8623368c', tlmc: '主观题' },
      { id: 'd04a0665-bd79-4094-8577-34ccd3099f52', name: '改错', tlid: '31b38675-1de4-4a42-a9d8-10bb8623368c', tlmc: '主观题' }
    ],
    panDuan: 'ea691280-774c-427d-86b8-b4c47616fa30',
    danXuan: '39967dba-900e-4348-9bd2-cdf1f0e014b2',
    duoXuan: '372f630d-e7ca-47fe-9766-38e5ae5554e4',
    piPei: '37d05cd3-7465-4cd4-ba09-20a5497a10f4',
    tianKong: '66cb4116-6a03-4dfe-a640-24666a094ecf',
    zuoTu: '82069608-2a51-46c8-b8f0-ede379d6612a',
    jiSuan: '61e2219f-433e-4755-a732-b96fc505541f',
    jianDa: '4c4f7020-f4e6-4472-b739-627152d71132',
    wenDa: '8cac5b6b-01f6-4fc7-a744-d25bb9222cef',
    lunShu: '8f6cd05c-874b-4fdc-ac99-8d97c4b95957',
    shiYan: '782ecc56-3a70-4d96-bac0-ef1c981dbf43',
    zuoWen: '89e26ffa-7393-42e0-acd6-caa551fba3a6',
    gaiCuo: 'd04a0665-bd79-4094-8577-34ccd3099f52'
  }
}

// 考试类型
export function getKsfs () {
  return {
    list: [
      { id: '27be441f-efe9-4dd7-b7f1-f0a3cc5aeaab', name: '笔试', value: '1' },
      { id: 'b0e59eca-a9a5-4406-8e34-256eecea3caf', name: '口试', value: '2' },
      { id: 'db095e2a-58eb-11ed-ae17-b8975afcfbb0', name: '面试', value: '3' },
      { id: 'e7ac0d33-58eb-11ed-ae17-b8975afcfbb0', name: '操作', value: '4' },
      { id: 'f64e0991-58eb-11ed-ae17-b8975afcfbb0', name: '机考', value: '5' },
      { id: 'f94ee149-58eb-11ed-ae17-b8975afcfbb0', name: '大作业', value: '6' },
      { id: 'fbeb4233-58eb-11ed-ae17-b8975afcfbb0', name: '实验报告', value: '7' },
      { id: '592e3b7d-4b8f-11ee-ace6-b8975afcfbb0', name: '线上考试', value: '99' },
      { id: 'fecc6515-58eb-11ed-ae17-b8975afcfbb0', name: '其他', value: '9' }
    ],
    bishi: '1',
    koushi: '2',
    mianshi: '3',
    caozuo: '4',
    jikao: '5',
    dazuoye: '6',
    shiyanbaogao: '7',
    xianshangkaoshi: '99',
    qita: '9'
  }
}

// 建筑物分类
export function getJzwfl () {
  return {
    list: [
      { id: '27a37740-80bb-4f58-9342-dd79893391e6', label: '房屋建筑', value: 1 },
      { id: '4b38c43b-cc9f-4380-82e0-65aff9314d66', label: '围墙', value: 2 },
      { id: '0dde8ef7-ee39-47f7-a818-b01da5fb4ae9', label: '校门', value: 3 },
      { id: 'a2ca57cb-78b5-46b0-83de-3dab0e6ffc1b', label: '其他', value: 9 }
    ],
    fangwujianzhu: '27a37740-80bb-4f58-9342-dd79893391e6',
    weiqiang: '4b38c43b-cc9f-4380-82e0-65aff9314d66',
    xiaomen: '0dde8ef7-ee39-47f7-a818-b01da5fb4ae9',
    qita: 'a2ca57cb-78b5-46b0-83de-3dab0e6ffc1b'
  }
}

// 培训资料格式
export function getPxzlgs () {
  return {
    list: [
      { id: '9401b006-a3ae-4cf5-9468-ed8c330a9382', label: '视频', value: 1 },
      { id: '2a64b5ea-c79b-4e30-8ce3-897369c85b11', label: 'PPT', value: 2 },
      { id: '42b2f072-4d17-43cd-9042-7cafa615e918', label: 'PDF', value: 3 }
    ],
    shipin: '9401b006-a3ae-4cf5-9468-ed8c330a9382',
    ppt: '2a64b5ea-c79b-4e30-8ce3-897369c85b11',
    pdf: '42b2f072-4d17-43cd-9042-7cafa615e918'
  }
}
// 培训资料发布范围
export function getPxzlFbfw () {
  return {
    list: [
      { id: 'e9ea68a3-8470-4691-81c6-87b9c089930e', label: '全体教职工', value: 1 },
      { id: '102601d2-1638-4bba-bf33-42e49a2327b8', label: '全体学生', value: 2 },
      { id: 'e89d140a-0c3c-464b-ba90-7c09692fcb3f', label: '全体教职工和全体学生', value: 3 },
      { id: '39a6eeef-8ded-41e0-9076-688a0e6506ea', label: '指定职务', value: 4 },
      { id: 'fc6a1e09-81aa-4032-b84a-7f70ab1a434f', label: '指定机构', value: 5 },
      { id: '3d30fd52-e33a-4733-9d78-8a8bafa79dc5', label: '指定教职工', value: 6 }
    ],
    quantijiaozhigong: 'e9ea68a3-8470-4691-81c6-87b9c089930e',
    quantixuesheng: '102601d2-1638-4bba-bf33-42e49a2327b8',
    quantijiaoshigonghexuesheng: 'e89d140a-0c3c-464b-ba90-7c09692fcb3f',
    zhidingzhiwu: '39a6eeef-8ded-41e0-9076-688a0e6506ea',
    zhidingjigou: 'fc6a1e09-81aa-4032-b84a-7f70ab1a434f',
    zhidingjiaozhigong: '3d30fd52-e33a-4733-9d78-8a8bafa79dc5'
  }
}

// 主题活动发布范围
export function getZthdFbfw () {
  return {
    list: [
      { id: '261c89ad-8690-4c35-b6b9-1f0c93e8d1b7', label: '全体教职工', value: 1 },
      { id: '306246f8-2256-4206-9e58-40adbacd7c3f', label: '全体学生', value: 2 },
      { id: '8ec64f6e-e434-4e6e-9c32-5b6b153c3559', label: '全体教职工和全体学生', value: 3 }
    ],
    quantijiaozhigong: '261c89ad-8690-4c35-b6b9-1f0c93e8d1b7',
    quantixuesheng: '306246f8-2256-4206-9e58-40adbacd7c3f',
    quantijiaoshigonghexuesheng: '8ec64f6e-e434-4e6e-9c32-5b6b153c3559'
  }
}

// 学生是否在校
export function getXsZxzt () {
  return {
    list: [
      { id: 'eb0a5e34-ca2a-4f8b-b8f6-da27b6086c38', bt: '在校', dm: '1' },
      { id: '1fb4863a-19cb-43e9-994e-8c48d1f173ba', bt: '不在校', dm: '2' }
    ],
    zaixiao: 'eb0a5e34-ca2a-4f8b-b8f6-da27b6086c38',
    buzaixiao: '1fb4863a-19cb-43e9-994e-8c48d1f173ba'
  }
}
